import React from 'react';
import FeaturedItems from '../../../shared/templates/CategoryTemplate/featured-items';
import AutosFeaturedPreview from './AutosFeaturedPreview';

export default function AutosFeatured(props) {
    return (
        <FeaturedItems 
            {...props}
            FeaturedItemPreview={AutosFeaturedPreview}
        />
    );
}